import { render, staticRenderFns } from "./chat_lt.vue?vue&type=template&id=5dbdf2c0&scoped=true&"
import script from "./chat_lt.vue?vue&type=script&lang=js&"
export * from "./chat_lt.vue?vue&type=script&lang=js&"
import style0 from "./chat_lt.vue?vue&type=style&index=0&id=5dbdf2c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbdf2c0",
  null
  
)

export default component.exports